import React, { useContext } from "react";
import { Stack, Typography } from "@mui/material";
import { Update } from "../App";
import gym1 from '../assets/icons/gym1.png'
const BodyPart = ({ item, bodyPart, setBodyPart }) => {
  const { Color, Icon,mode } = useContext(Update);
  return (
    <Stack
      type="button"
      alignItems="center"
      justifyContent="center"
      className="bodyPart-card"
      sx={{
        borderTop: bodyPart === item ? `4px solid ${mode==="light"?("red" ): ('blue')}` : "",
        backgroundColor: "white",
        borderBottomRadius: "20px",
        width: "270px",
        height: "280px",
        cursor: "pointer",
        gap: "47px",
      }}
      onClick={() => {
        setBodyPart(item);
        window.scrollTo({ top: 1700, behavior: "smooth" });
      
      }}
    >
      <img src={mode==="light"?(Icon):(gym1)}  alt="Dumbell" style={{ width: "40px", height: "40px" }} />
      <Typography
        fontSize={20}
        fontWeight="bold"
        color={mode==="light"?("error" ): ('blue')}
        textTransform="capitalize"
      >
        {item}
      </Typography>
    </Stack>
  );
};

export default BodyPart;
